import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import EventDataImporter from "../components/EventDataImporter";
import { useNavigate, useParams } from "react-router-dom";
import { Axios } from "../App";

const CSVImporter = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    const getEventData = async () => {
      return await Axios.post("events/getEventData.php", { id: id }).then(
        ({ data }) => {
          setData(data);
        }
      );
    };

    const isEventExists = () => {
      return Axios.post("events/isEventExists.php", {
        id: id,
      })
        .then(({ data }) => {
          if (!data?.isExists) navigate("/event-manager");
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const fetchData = async () => {
      await isEventExists();
      await getEventData();
    };
    fetchData();
  }, [id, navigate]);

  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={12} md={12}>
        <h2>Résztvevők hozzáadása CSV file-ból</h2>
        {/* @ts-ignore */}
        <p>Esemény neve: {data?.name}</p>
        <p>
          Az importálás után minden korábbi résztvevő törlödni fog listából és
          csak az Excelben található résztvevők lesznek rajta a listán.
        </p>
      </Grid>
      <Grid item xs={12} md={12}>
        <EventDataImporter />
      </Grid>
    </Grid>
  );
};

export default React.memo(CSVImporter);
